/**
 * Copyright IBM Corp. 2022, 2026
 */

import Image from 'next/image'
import classNames from 'classnames'
import { StructuredText, renderNodeRule } from 'react-datocms'
import { isParagraph } from 'datocms-structured-text-utils'
import { StandaloneLink, Text } from '@hashicorp/mds-react/components'
import { type TabsLeftTabPanelFieldsFragment } from 'types/dato'
import s from './style.module.css'

const ImageTextPanel = ({
	image,
	headline,
	description,
	cta,
}: TabsLeftTabPanelFieldsFragment) => {
	return (
		<div className={s.root}>
			{image && (
				<div className={s.panelImageContainer}>
					<Image {...image} alt={image.alt || ''} className={s.panelImage} />
				</div>
			)}
			<div
				className={classNames(s.panelContent, {
					[s.panelContentWithImage]: image,
					[s.panelContentWithoutImage]: !image,
				})}
			>
				<Text.DisplayExpressive size="200" weight="bold" color="strong">
					{headline}
				</Text.DisplayExpressive>
				<StructuredText
					data={description}
					customNodeRules={[
						renderNodeRule(isParagraph, ({ key, children }) => {
							return (
								<Text.Body color="faint" tag="p" size="200" key={key}>
									{children}
								</Text.Body>
							)
						}),
					]}
				/>
				{cta && cta[0] && (
					<StandaloneLink
						{...cta[0]}
						icon="chevron-right"
						iconPosition="trailing"
						color="secondary"
						className={s.cta}
						size="small"
					/>
				)}
			</div>
		</div>
	)
}

export default ImageTextPanel
